// removed by extract-text-webpack-plugin
module.exports = {"footer":"styles__footer__2tvn_","footerSocial":"styles__footerSocial__sn2JT","footerImage":"styles__footerImage__19aWr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/styles.scss
// module id = 393
// module chunks = 0